import { Assignation } from '../context/types'
import _ from 'lodash'
import { langIndex2AppLang } from './useTranslation'
import { stm2Asgn } from '../utils/values/stm2Asgn'
import { Scanning360Params } from '../parameters/types'
import { LOCAL_MAP } from './constants'
const removeDisabled = (s: Assignation) => s.preferredType360 !== 'disabled'

export const getStatements = (
    langIndex: number = 2, // EN - FIXME use local instead? enum?
    params360?: Scanning360Params
): Assignation[] => {
    const appLang = langIndex2AppLang(langIndex)
    const { statements, extra360 } = LOCAL_MAP[appLang]
    return params360?.is360
        ? [
              ...statements.map(stm2Asgn(params360)).filter(removeDisabled),
              ...extra360.map(stm2Asgn(params360)).filter(removeDisabled),
          ]
        : [...statements.map(stm2Asgn({ is360: false }))]
}
